export default {
  SET_ROLES(state, roles) {
    state.roles = roles;
  }
};
